export const OPERATION_TYPE = {
  ADD: 'ADD',
  CANCEL: 'CAN',
  EXCHANGE: 'EX'
};
